import Vue from "vue";
import Vuex from "vuex";
import permission from "./modules/permission";
import theme from "./modules/theme";
import setting from "./modules/setting";
import { state, actions, mutations, getters } from "./modules/syncFilter";
import { axios as $axios, instance as axios } from "../services/axios";
Vue.use(Vuex);

export const store = new Vuex.Store({
  namespaced: true,
  state: {
    formatDateNew: "DD/MM/YYYY",
    formatDate: "DD MMM YYYY",
    formatDateTime: "DD MMM YYYY HH:mm",
    formatTime: "HH:mm",
    screenSize: {
      width: 0,
      height: 0,
    },
    currentLanguage: "1",
    ...state,
  },
  getters: {
    ...getters,
  },
  mutations: {
    setScreenSize(state, screenSize) {
      state.screenSize.width = screenSize.width;
      state.screenSize.height = screenSize.height;
    },

    ...mutations,
  },
  actions: {
    clearFilter: async ({ commit, state }) => {},



    ...actions,
  },
  modules: {
    theme,
    setting,
    permission,
  },
});
